import { createAction } from "@ngrx/store";

export const openSidenav = createAction("[UI] Open Sidenav");
export const closeSidenav = createAction("[UI] Close Sidenav");
